<template>
  <li class="flex items-center gap-4 p-5 border border-slate-300 dark:border-zinc-700 rounded-10" :data-testid="`custom-template-card-${template.slot}`">
    <dl class="grow dark:text-zinc-300">
      <dt class="font-bold">{{ template.name }}</dt>
      <dd v-if="template.description" class="text-sm pb-1">
        {{ template.description }}
      </dd>
      <dd class="text-sm">
        <FormKit type="toggle" label="Apply automatically" :model-value="template.isDefault" @input="handleToggle" />
      </dd>
    </dl>
    <div class="flex flex-none gap-3">
      <Button
        v-if="isOwner"
        type="link"
        variant="black"
        icon="general.cog"
        :data-testid="`template-${template.slot}-configure-button`"
        @click="$emit('configure', template.slot)"
      />
      <Button type="solid" variant="gray" icon="general.bolt" :data-testid="`template-${template.slot}-apply-button`" @click="$emit('apply', template.slot)">
        Apply
      </Button>
    </div>
  </li>
</template>

<script setup lang="ts">
import { Button } from '@/storybook/button';
import type { Template } from '../../store/useViewerTemplateStore';

interface Props {
  template: Template;
  isOwner: boolean;
}

interface Emits {
  (e: 'toggleDefault', template: Template): void;
  (e: 'configure', slot: string): void;
  (e: 'apply', slot: string): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const handleToggle = (newValue: boolean) => {
  // Only emit when the new value differs from current prop (user initiated change)
  if (newValue !== props.template.isDefault) {
    emit('toggleDefault', props.template);
  }
};
</script>
